var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.682,
    height: 40.068,
    viewBox: "0 0 16.682 20.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    fill: "#9b9b9b",
    stroke: "#9b9b9b",
    d: "M295.462-448.1a3.37 3.37 0 0 1-3.336-3.362 3.371 3.371 0 0 1 3.363-3.335 3.364 3.364 0 0 1 3.334 3.362 3.365 3.365 0 0 1-3.361 3.335m.005-8.092a4.748 4.748 0 0 0-4.737 4.742 4.747 4.747 0 0 0 4.735 4.745 4.74 4.74 0 0 0 4.752-4.723 4.736 4.736 0 0 0-4.75-4.764",
    clipRule: "evenodd",
    "data-name": "Path 406",
    transform: "translate(-290.731 456.194)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    d: "M283-424.915h35.085V-460H283z",
    className: "clsd-2",
    "data-name": "Path 405",
    transform: "translate(-283 460)"
  })), /*#__PURE__*/React.createElement("style", null, "\n          .clsd-2{fill:#9b9b9b;stroke:#9b9b9b}\n      "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(-1.017 1.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(.617 1.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(1 -2.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    fill: "none",
    stroke: "#9b9b9b",
    strokeLinejoin: "round",
    strokeWidth: "1.2px",
    d: "M288.009-438.089v-3.511c0-2.291 1.3-4.517 4.331-4.517h7.181c3.4 0 3.97 2.375 3.97 4.517v3.767",
    "data-name": "Path 403",
    transform: "translate(-288.009 457.902)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    clipPath: "url(#clip-path)",
    "data-name": "Group 492",
    transform: "translate(2.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    clipPath: "url(#clip-path-2)",
    "data-name": "Group 491",
    transform: "translate(-9.041 -4.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    d: "M285.731-461.194h21.182v21.182h-21.182z",
    className: "clsd-2",
    "data-name": "Path 404",
    transform: "translate(-282.537 459.798)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountPlaceholder);
export default __webpack_public_path__ + "static/media/accountPlaceholder.621e40d9.svg";
export { ForwardRef as ReactComponent };